import { render, staticRenderFns } from "./eleModelManage.vue?vue&type=template&id=20a65434&scoped=true&"
import script from "./eleModelManage.vue?vue&type=script&lang=js&"
export * from "./eleModelManage.vue?vue&type=script&lang=js&"
import style0 from "./eleModelManage.vue?vue&type=style&index=0&id=20a65434&prod&scoped=true&lang=css&"
import style1 from "./eleModelManage.vue?vue&type=style&index=1&id=20a65434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a65434",
  null
  
)

export default component.exports